import React from 'react';

import { MediumClear } from '@crehana/icons';
import { PrimaryButton, Snackbar, BottomSheet, colors } from '@crehana/ui';

import { useCrehanaLiveTranslations } from 'Jsx/CrehanaLive/hooks';

import Media from 'Jsx/Shared/ui/Media';

const MembershipSnackbar: React.FC<{
  isInThePast: boolean;
  liveCountdownToStart: {
    finished: boolean;
  };
}> = ({ isInThePast, liveCountdownToStart }) => {
  const { t } = useCrehanaLiveTranslations();

  const [snackbar, setSnackbar] = React.useState<{
    isOpen: boolean;
    type: 'start-live-snackbar' | 'ending-live-snackbark' | '';
    title: string;
    message: string;
    buttonLabel: string;
  }>({
    isOpen: false,
    type: '',
    title: '',
    message: '',
    buttonLabel: '',
  });

  React.useEffect(() => {
    if (!isInThePast && liveCountdownToStart.finished && snackbar.type === '') {
      const MILISECONDS_IN_A_MINUT = 1000 * 60;

      setSnackbar({
        type: 'start-live-snackbar',
        isOpen: true,
        title: t('COURSE_TO_GROW'),
        message: t('COURSE_TO_GROW'),
        buttonLabel: t('CORSE_TO_GROW_PREMIUM'),
      });

      // Prepare the ending snackbar
      setTimeout(() => {
        setSnackbar({
          type: 'ending-live-snackbark',
          isOpen: true,
          title: t('LIVE_END'),
          message: t('LIVE_MESSAGE_END'),
          buttonLabel: t('LIVE_END_LABEL'),
        });
      }, MILISECONDS_IN_A_MINUT * 35);
    }
  }, [isInThePast, liveCountdownToStart, snackbar.type]);

  const Content = (
    <div>
      <p className="mb-8 font-subtitle2">{snackbar.title}</p>
      <p className="font-body3 text-gray-dark">{snackbar.message}</p>
      <div className="mt-24 sm:text-right">
        <PrimaryButton
          full
          className="w-full sm:max-w-212"
          label={snackbar.buttonLabel}
          onClick={() => {
            window.open('/premium/');
          }}
        />
      </div>
    </div>
  );

  const dismissSnackbar = () => {
    setSnackbar(prevState => ({
      ...prevState,
      isOpen: false,
    }));
  };

  return (
    <React.Fragment>
      <Media from="xs" until="sm">
        <BottomSheet
          className="py-24 px-20"
          open={snackbar.isOpen}
          onDismiss={dismissSnackbar}
          hideBackdrop
        >
          <div className="relative">
            <div
              className="absolute top-0 right-0"
              onClick={dismissSnackbar}
              onKeyDown={dismissSnackbar}
            >
              <MediumClear size={16} color={colors.baseLighter} />
            </div>
            {Content}
          </div>
        </BottomSheet>
      </Media>
      <Media from="sm">
        <Snackbar
          open={snackbar.isOpen}
          onDismiss={dismissSnackbar}
          showCloseBtn
          className="py-8 px-16 sm:py-24 sm:px-24"
        >
          <div style={{ maxWidth: 420 }}>{Content}</div>
        </Snackbar>
      </Media>
    </React.Fragment>
  );
};

export default MembershipSnackbar;
